module.exports = __webpack_public_path__ + "media/assets/systems-map-icons/FariaOne-56a7191bcb1875cf6d2d225573a9676f53c03f9b07494bbbc1d48adaff56654d.png";